import { constants } from '@bedc/constants';

import { Request as BaseRequest } from '../../../../api/generic/search/Request';

import { SearchDataTableType } from './SearchDataTableType';

export const WoHMaterialType = SearchDataTableType({
	request: BaseRequest({
		sortFields: constants.wholeHouse.material.sortFields,
		columnFields: constants.wholeHouse.material.columnFields,
		standardFilterFields: constants.wholeHouse.material.osStandardFilterFields,
		dateFilterFields: constants.wholeHouse.material.osDateFilterFields,
		stageStatusFilterFields: [] as const,
		booleanFilterFields: [] as const,
	}),
	columnFields: constants.wholeHouse.material.columnFields,
	filterIds: constants.wholeHouse.material.filterFields,
});
